import lightFormat from 'date-fns/lightFormat';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatRemovalDate } from '../../components/ChatRemovalDate';
import { offerSelector, userIdSelector } from '../../selectors';

export const ChatRemovalDateContainer: React.VFC = () => {
  const offer = useSelector(offerSelector);
  const userId = useSelector(userIdSelector);

  if (!offer?.removalFromPublicationDate) {
    return null;
  }

  // Не показываем надпись пользователю, разместившему объявление
  if (offer?.userId === userId) {
    return null;
  }

  const date = lightFormat(new Date(offer.removalFromPublicationDate), 'HH:mm dd.MM.yyyy');

  return <ChatRemovalDate date={date} />;
};
